import React from 'react';
import Chat from './Chat';
import {useSessionConfiguration} from 'util/SessionConfigurationContext';
import UniversalEmptyPageHeader from 'components/universal/UniversalEmptyPageHeader';

function ChatPanel() {
    const {isDesktopView} = useSessionConfiguration();
    if (isDesktopView) {
        return (
            <div className="chat-panel">
                <UniversalEmptyPageHeader image="chat" text="Chat"/>
                <Chat isMain/>
            </div>
        );
    }
    return (
        <div className="chat-panel-mobile">
            <div className="chat-header-fixed">
                <UniversalEmptyPageHeader image="chat" text="Chat"/>
            </div>
            <div className="chat-content">
                <Chat isMain/>
            </div>
        </div>
    );
}


export default ChatPanel;
